import React, { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Text,
  Button,
  Image,
  Flex,
  SimpleGrid,
  Container,
  Badge,
  HStack,
  VStack,
  Icon,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { FiCheck, FiArrowRight, FiShield, FiDatabase, FiAward } from "react-icons/fi";
import { apiUrl } from "../ApiUrl/ApiUrl";
import Slider from "react-slick";
import { Link, NavLink } from "react-router-dom";

function Digilegal() {
  const [fashion, setFashion] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data2, setData2] = useState(null);
  const [itax, setItax] = useState([]);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const getFashion = () => {
    setLoading(true);
    fetch(`${apiUrl}/public/allbooks`)
      .then((res) => res.json())
      .then((res) => setFashion(res))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  };

  const getPrice2 = () => {
    setLoading(true);
    fetch(`${apiUrl}/public/singleBook?bid=1475`)
      .then((res) => res.json())
      .then((res) => setData2(res))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  };

  const getPrice3 = () => {
    setLoading(true);
    fetch(`${apiUrl}/public/allTaxmanSoftware?Maincatname=software&Author=Digilegal-Bombay`)
      .then((res) => res.json())
      .then((res) => setItax(res))
      .catch((err) => {
        setError(true);
        console.error("Error fetching data:", err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getFashion();
    getPrice2();
    getPrice3();
  }, []);

  return (
    <Box bg="#F8FAFC" minH="100vh" pb={16}>
      {/* SaaS Hero Header */}
      <Box
        bgGradient="linear(to-b, #0B132B, #162237)"
        color="white"
        py={{ base: 12, md: 16 }}
        px={{ base: 4, md: 8 }}
        textAlign="center"
      >
        <Container maxW="900px">
          <Badge
            bg="whiteAlpha.200"
            color="#EAB308"
            px={3}
            py={1}
            rounded="full"
            fontSize="xs"
            fontWeight="bold"
            letterSpacing="wider"
            mb={4}
          >
            ⚖️ TRUSTED BY THE LEGAL FRATERNITY FOR 47+ YEARS
          </Badge>

          <Heading
            as="h1"
            fontSize={{ base: "30px", md: "46px" }}
            fontWeight="extrabold"
            letterSpacing="tight"
            mb={3}
          >
            Digilegal (Bombay Cases Reporter)
          </Heading>

          <Text
            fontSize={{ base: "sm", md: "lg" }}
            color="gray.300"
            maxW="750px"
            mx="auto"
            lineHeight="tall"
          >
            The authoritative legal reporter and comprehensive case archive for the Bombay High Court, Goa Bench, Nagpur, and Maharashtra judicial tribunals.
          </Text>
        </Container>
      </Box>

      {/* Main Content */}
      <Container maxW="1200px" mt={-8} px={{ base: 3, md: 6 }}>
        <Box
          bg="white"
          rounded="2xl"
          border="1px solid"
          borderColor="gray.200"
          shadow="sm"
          p={{ base: 5, md: 8 }}
        >
          <Flex direction={{ base: "column", lg: "row" }} gap={{ base: 8, lg: 10 }} align="center">
            {/* Left: Plans & Offer */}
            <Box w={{ base: "100%", lg: "55%" }}>
              <HStack spacing={2} mb={1}>
                <Text fontSize="xs" fontWeight="bold" color="#EAB308" textTransform="uppercase" letterSpacing="wider">
                  Flagship Subscription
                </Text>
              </HStack>
              <Heading size="lg" color="#162237" fontWeight="bold" mb={6}>
                Library Edition Access
              </Heading>

              <Box
                p={{ base: 5, md: 6 }}
                rounded="xl"
                border="2px solid"
                borderColor="#162237"
                bg="white"
                shadow="sm"
                position="relative"
              >
                <Badge
                  position="absolute"
                  top={-3}
                  right={4}
                  bg="#162237"
                  color="#EAB308"
                  fontSize="10px"
                  px={2.5}
                  py={0.5}
                  rounded="full"
                  fontWeight="bold"
                >
                  BOMBAY CASES REPORTER
                </Badge>

                <Flex justify="space-between" align="flex-start" wrap="wrap" gap={2}>
                  <Box>
                    <Heading size="md" color="#162237">
                      Library Edition Complete
                    </Heading>
                    <Text fontSize="xs" color="gray.600" mt={1}>
                      Supreme Court, All High Courts, Tribunals & Commissions, Privy Council & Foreign Courts
                    </Text>
                  </Box>

                  <Box textAlign={{ base: "left", sm: "right" }}>
                    <HStack spacing={2} align="baseline">
                      <Text fontSize="2xl" fontWeight="extrabold" color="#162237">
                        ₹{data2?.descprice ? data2.descprice : "—"}
                      </Text>
                      {data2?.originalprice && (
                        <Text fontSize="xs" color="gray.400" as="del">
                          ₹{data2.originalprice}
                        </Text>
                      )}
                    </HStack>
                    <Text fontSize="10px" color="gray.500">+ 18% GST Applicable</Text>
                  </Box>
                </Flex>

                <VStack spacing={2} mt={4} pt={4} borderTop="1px solid" borderColor="gray.100" align="stretch">
                  <HStack spacing={2} fontSize="xs" color="gray.700">
                    <Icon as={FiCheck} color="green.600" boxSize={3.5} />
                    <Text>Complete Bombay Cases Reporter archives</Text>
                  </HStack>
                  <HStack spacing={2} fontSize="xs" color="gray.700">
                    <Icon as={FiCheck} color="green.600" boxSize={3.5} />
                    <Text>Maharashtra State Acts & Statutory Rules</Text>
                  </HStack>
                  <HStack spacing={2} fontSize="xs" color="gray.700">
                    <Icon as={FiCheck} color="green.600" boxSize={3.5} />
                    <Text>Multi-user Chamber & Firm Licenses Available</Text>
                  </HStack>
                </VStack>

                <Link to="/products/view/1475">
                  <Button
                    mt={5}
                    w="100%"
                    size="md"
                    bg="#162237"
                    color="white"
                    _hover={{ bg: "#0F172A" }}
                    rounded="lg"
                    rightIcon={<FiArrowRight />}
                  >
                    Subscribe to Library Edition
                  </Button>
                </Link>
              </Box>
            </Box>

            {/* Right: Product Banner Image */}
            <Box w={{ base: "100%", lg: "45%" }} textAlign="center">
              <Box
                p={4}
                bg="#F1F5F9"
                rounded="2xl"
                border="1px solid"
                borderColor="gray.200"
              >
                <Image
                  src="./digilegal.jpeg"
                  alt="Digilegal Logo"
                  maxH="380px"
                  mx="auto"
                  objectFit="contain"
                  rounded="xl"
                  fallbackSrc="https://navneetlawstudio.com/logo.png"
                />
              </Box>
            </Box>
          </Flex>

          {/* Module Packages Table */}
          {itax.length > 0 && (
            <Box mt={10} pt={8} borderTop="1px solid" borderColor="gray.200">
              <HStack spacing={2} mb={1}>
                <Text fontSize="xs" fontWeight="bold" color="#EAB308" textTransform="uppercase" letterSpacing="wider">
                  Partner Add-ons
                </Text>
              </HStack>
              <Heading size="md" color="#162237" mb={4}>
                Available Modules & Packages
              </Heading>

              <Box overflowX="auto" rounded="xl" border="1px solid" borderColor="gray.200">
                <Table variant="simple" size="sm">
                  <Thead bg="#F8FAFC">
                    <Tr>
                      <Th color="gray.600">Module Name</Th>
                      <Th color="gray.600">Price (INR)</Th>
                      <Th color="gray.600" textAlign="right">Action</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {itax.map((book) => (
                      <Tr key={book.id} _hover={{ bg: "gray.50" }}>
                        <Td fontWeight="medium" color="gray.800">{book.booktitle}</Td>
                        <Td fontWeight="bold" color="#162237">₹{book.descprice}</Td>
                        <Td textAlign="right">
                          <Link to={`/products/view/${book.id}`}>
                            <Button size="xs" colorScheme="navy" variant="outline" rounded="md">
                              Buy Module
                            </Button>
                          </Link>
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </Box>
            </Box>
          )}
        </Box>

        {/* Feature Highlights Grid */}
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6} mt={8}>
          <Box bg="white" p={5} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
            <Flex w="40px" h="40px" rounded="lg" bg="blue.50" color="#162237" align="center" justify="center" mb={3} fontSize="18px">
              <FiDatabase />
            </Flex>
            <Text fontSize="sm" fontWeight="bold" color="gray.800" mb={1}>
              Full Bombay Jurisprudence
            </Text>
            <Text fontSize="xs" color="gray.600" lineHeight="tall">
              Unrivalled collection of Bombay High Court, Nagpur Bench, Aurangabad, and Panaji Goa judgments.
            </Text>
          </Box>

          <Box bg="white" p={5} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
            <Flex w="40px" h="40px" rounded="lg" bg="purple.50" color="purple.700" align="center" justify="center" mb={3} fontSize="18px">
              <FiAward />
            </Flex>
            <Text fontSize="sm" fontWeight="bold" color="gray.800" mb={1}>
              Official Citations (BCR)
            </Text>
            <Text fontSize="xs" color="gray.600" lineHeight="tall">
              Official Bombay Cases Reporter page numbers, volume references, and headnotes trusted in courtroom practice.
            </Text>
          </Box>

          <Box bg="white" p={5} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
            <Flex w="40px" h="40px" rounded="lg" bg="green.50" color="green.700" align="center" justify="center" mb={3} fontSize="18px">
              <FiShield />
            </Flex>
            <Text fontSize="sm" fontWeight="bold" color="gray.800" mb={1}>
              Zero Downtime Cloud
            </Text>
            <Text fontSize="xs" color="gray.600" lineHeight="tall">
              High speed query engines delivering exact judicial precedent matches within fractions of a second.
            </Text>
          </Box>
        </SimpleGrid>

        {/* Recommended Softwares Slider */}
        <Box mt={12}>
          <Flex justify="space-between" align="center" mb={4}>
            <Box>
              <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase" letterSpacing="wider">
                Explore More Tools
              </Text>
              <Heading size="md" color="#162237">
                Recommended Legal Softwares
              </Heading>
            </Box>
            <Link to="/software">
              <Button size="xs" variant="outline" colorScheme="navy">
                View All Softwares
              </Button>
            </Link>
          </Flex>

          <Box
            p={4}
            bg="white"
            rounded="xl"
            border="1px solid"
            borderColor="gray.200"
            shadow="xs"
          >
            <Slider {...settings}>
              {fashion
                .filter((item) => item.maincatname === "software" || item.subcatname === "software")
                .map((item) => (
                  <Box key={item.id} p={2}>
                    <NavLink to={`/products/view/${item.id}`}>
                      <Box
                        bg="gray.50"
                        rounded="lg"
                        border="1px solid"
                        borderColor="gray.200"
                        p={3}
                        textAlign="center"
                        _hover={{ borderColor: "#162237", bg: "white", shadow: "sm" }}
                        transition="all 0.2s"
                        h="100%"
                      >
                        <Image
                          src={item.imagePath}
                          alt={item.booktitle}
                          h="120px"
                          mx="auto"
                          objectFit="contain"
                          fallbackSrc="https://navneetlawstudio.com/logo.png"
                        />
                        <Text
                          fontSize="xs"
                          fontWeight="bold"
                          color="gray.800"
                          mt={2}
                          noOfLines={2}
                          minH="32px"
                        >
                          {item.booktitle}
                        </Text>
                        <HStack justify="center" spacing={2} mt={1}>
                          <Text fontSize="xs" fontWeight="bold" color="#162237">
                            ₹{item.descprice}
                          </Text>
                          {item.originalprice && (
                            <Text fontSize="10px" color="gray.400" as="del">
                              ₹{item.originalprice}
                            </Text>
                          )}
                        </HStack>
                      </Box>
                    </NavLink>
                  </Box>
                ))}
            </Slider>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Digilegal;

